import { Spinner } from '@chakra-ui/react';
import React, { Suspense } from 'react';
import ErrorBoundaryWrapper from '../ErrorAwareAlertBox/ErrorBoundaryWrapper';
const SuspenseWrapper = ({ children, fallback, noun }) => (React.createElement(ErrorBoundaryWrapper, { noun: noun },
    React.createElement(Suspense, { fallback: fallback ?? React.createElement(Spinner, { size: "lg", m: 2 }) }, children)));
export default SuspenseWrapper;
